module.exports = __webpack_public_path__ + "img/3-Uso de suelo.df5b90f0.jpg";